import { memo, useMemo } from "react";
import Link from "next/link";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";

const ROUTES_BY_ID = {
  1: "/partnership/leasing-partners",
  2: "/partnership/factoring-partners",
  3: "/partnership/business-partners",
  // 4: "/partnership/contact-now-merchant",
};

const BASE_BUTTON_SX = {
  textAlign: "center",
  borderRadius: "8px",
  padding: { xs: "20px", sm: "2px", md: "2px", lg: "2px" },
  fontSize: { xs: "14px", sm: "16px" },
  width: { xs: "210px", sm: "200px", md: "200px", lg: "200px" },
  height: { xs: "48px", sm: "48px", md: "48px" },
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  cursor: "pointer",
  boxSizing: "border-box",
  transition:
    "background-color .2s ease, color .2s ease, border-color .2s ease",
};

const INACTIVE_BUTTON_SX = {
  ...BASE_BUTTON_SX,
  color: "#111828",
  backgroundColor: "#F1F1F1",
  border: "1px solid #F1F1F1",
};

const ACTIVE_BUTTON_SX = {
  ...BASE_BUTTON_SX,
  color: "#F18222",
  backgroundColor: "#F182220D",
  border: "1px solid #F18222",
  fontWeight: 700,
};

const WRAPPER_SX = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: { xs: "9px", sm: "10px", md: "17px", lg: "20px" },
};

function normalizePath(path = "") {
  return path
    .split("?")[0]
    .split("#")[0]
    .replace(/^\/(ar|en)(?=\/)/, "")
    .replace(/\/+$/, "");
}

function PartenerTypes() {
  const router = useRouter();
  const { t } = useI18n();

  const currentPath = normalizePath(router.pathname || router.asPath);

  const items = useMemo(() => {
    return (t?.partner_types || []).map((item) => ({
      ...item,
      href: ROUTES_BY_ID[String(item.id)] || "#",
    }));
  }, [t]);

  return (
    <Box component="nav" aria-label="Partner types">
      <Box sx={WRAPPER_SX}>
        {items.map((item) => {
          const href = item.href;
          const isActive = currentPath === normalizePath(href);

          return (
            <Box
              key={item.id}
              component={Link}
              href={href}
              sx={isActive ? ACTIVE_BUTTON_SX : INACTIVE_BUTTON_SX}
              aria-current={isActive ? "page" : undefined}
            >
              {item.title}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default memo(PartenerTypes);
